/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { MatrixDependencies } from './dependenciesMatrixClass.generated';
import { createDenseMatrixClass } from '../../factoriesAny.js';
export var DenseMatrixDependencies = {
  MatrixDependencies: MatrixDependencies,
  createDenseMatrixClass: createDenseMatrixClass
};